<rask-tabs class="child" layout="child" [wrap]="true" [useRoute]="false">
  @if (!iskontraktTypGrot) {
    <rask-tab #tradslag label="Trädslag">
      @if (tradslag.visited) {
        <rask-forkalkyl-tradslag [kontraktReadonly]="kontraktReadonly || atgard.isUtfort">
        </rask-forkalkyl-tradslag>
      }
    </rask-tab>
  }
  @if (canView()) {
    <rask-tab #virkeskostnad label="Virkeskostnad">
      @if (virkeskostnad.visited) {
        <rask-atgard-virkeskostnad>
        </rask-atgard-virkeskostnad>
      }
    </rask-tab>
  }
  @if (canView()) {
    <rask-tab #avverkningskostnad label="Avverkningskostnad">
      @if (avverkningskostnad.visited) {
        <rask-atgard-avverkningskostnad>
        </rask-atgard-avverkningskostnad>
      }
    </rask-tab>
  }
  @if (canView()) {
    <rask-tab #nettoberakning label="Nettoberäkning">
      @if (nettoberakning.visited) {
        <rask-forkalkyl-nettoberakning [atgardGuid]="atgard.guid">
        </rask-forkalkyl-nettoberakning>
      }
    </rask-tab>
  }
</rask-tabs>